﻿import BaseTracker from './tk.base.tracker';
import { TrackBasket, TrackerOptions, TrackFavorite, TrackItem } from './tk.tracker';

export default class TKMatomoTracker extends BaseTracker {
    constructor(trackingId: string, options?: TrackerOptions) {
        super(trackingId, window._mtm || [], `https://matomo01.opacc.net/js/container_%KEY.js`, options);

        this.basketEventMap = options?.basketEventMap || {
            added: 'opc_cart_add',
            deleted: 'opc_cart_remove',
            changed: 'opc_cart_update',
        };
        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'opc_wishlist_add',
            deleted: 'opc_wishlist_remove',
        };
    }

    async init() {
        await this.loadScript();
        this.initMatomo();
        console.log('Matomo Tag Manager successfully loaded');
    }

    initMatomo() {
        this.tracker.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start',
        });
    }

    push(item: TrackItem) {
        this.tracker.push(item);
    }

    pushBasket(item: TrackBasket) {
        this.tracker.push({
            event: this.basketEventMap[item.event as keyof typeof this.basketEventMap],
            location: item.location,
            currency: item.currency,
            value: item.value,
            items: item.items,
        });
    }

    pushFavorite(item: TrackFavorite) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action as keyof typeof this.favoriteEventMap],
            location: window.location.href,
            category: item.category,
            action: this.favoriteActionMap[item.action as keyof typeof this.favoriteActionMap],
            name: item.name,
            value: item.value,
        });
    }
}